import React from "react";
import { useNavigate } from "react-router-dom";
import { REPORT_VIEWERS } from "../../constants/roles";
import { useCurrentUser } from "../../utilities/currentUser";
import { userHasAnyRole } from "../../utils/leadershipRoles";

const AccessDenied = () => {
  const navigate = useNavigate();
  const { user } = useCurrentUser();

  // Whoever may open the dashboard (Admin, Superadmin, Manager) lands on it, everyone else on their profile.
  const homePath = userHasAnyRole(user, REPORT_VIEWERS) ? "/dashboard" : "/profile";

  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-5 text-center">
      <h1 className="display-6 text-danger mb-3">You don't have access to this page</h1>
      <p className="lead text-secondary mb-4">
        Your role does not allow you to view this page. If you think this is a mistake, ask an
        administrator to check your roles.
      </p>
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => navigate(homePath, { replace: true })}
      >
        Go to my home
      </button>
    </div>
  );
};

export default AccessDenied;
